export default "__VITE_ASSET__CCWwN96T__"